import { Component, OnInit, Input, ViewChild, Output, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserFamilySelectDropdownComponent } from '../user-family-select-dropdown/user-family-select-dropdown.component';

@Component({
    selector: 'app-user-family-select',
    templateUrl: './user-family-select.component.html',
    styleUrls: ['./user-family-select.component.scss'],
})
export class UserFamilySelectComponent implements OnInit {
    @Input() label: string;
    @Input() placeholder: string;
    @Input() form: FormGroup;
    @Input() controlName: string;

    @Input()
    get selected() {
        return this.form.get(this.controlName)?.value;
    }
    set selected(data) {
        this.form.controls[this.controlName].setValue(data);
    }

    @ViewChild(UserFamilySelectDropdownComponent)
    public dropdown: UserFamilySelectDropdownComponent;

    @Input() options: any[];
    @Output() selectChange = new EventEmitter();

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.cdr.detectChanges();
    }

    select(option: any) {
        this.selected = option;
        this.selectChange.emit(this.selected);
        this.hideDropdown();
    }

    public toggleDropdown(): void {
        this.dropdown.showing ? this.hideDropdown() : this.showDropdown();
    }

    public showDropdown() {
        this.dropdown.show();
    }

    public hideDropdown() {
        this.dropdown.hide();
    }

    public onTouched: () => void = () => {};
    public OnChange: () => void = () => {};

    writeValue(obj: any): void {
        this.selected = obj;
    }

    registerOnChange(fn: any): void {
        this.form.valueChanges.subscribe(fn);
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
}
